export const firebaseConfig = {
    apiKey: "AIzaSyAP8tm5yH5USaAzJC9xW7YWOlIrYLFIwyk",
    authDomain: "cliv-27043.firebaseapp.com",
    projectId: "cliv-27043",
    storageBucket: "cliv-27043.appspot.com",
    messagingSenderId: "403091047359",
    appId: "1:403091047359:web:cd8202515085da1723170a",
    measurementId: "G-Q3Y0NBEWKF"
};